import { createPortal } from '@/features/common/contexts/Portal'

export const { Provider: CancelOrderDialogPortalProvider, usePortal: useCancelOrderDialogPortal } =
    createPortal()
